import { useState } from "react";
import { Link, useLocation, useNavigate } from "fusion-plugin-react-router";
import UberLogo from "../../../../shared/components/uberLogo";
import { assetsPath } from "../../../../shared/utils/assetsPath";
import LandingMobileMenu from "./LandingMobileMenu";

const LandingNavbar = ({ menuItems }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleToggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/landing" className="navbar-left">
          <UberLogo color="white" width={40} height={40} />
        </Link>
        <div className="navbar-right">
          <Link to="/landing/contact" className="help-btn">
            <img src={assetsPath.questionMark} alt="Help" />
            <div>Help</div>
          </Link>
          <button className="hamburger" onClick={handleToggleMenu}>
            <img src={assetsPath.burgerMenu} alt="menu" />
          </button>
        </div>
      </div>
      <LandingMobileMenu
        menuItems={menuItems}
        location={location}
        navigate={navigate}
        isOpen={isMenuOpen}
        onClose={() => setIsMenuOpen(false)}
      />
    </nav>
  );
};

export default LandingNavbar;
